export default __webpack_public_path__ + "static/osvaldo-carvalho-2fbb8de29896298d4a0fde219357d638.png";